import { render, staticRenderFns } from "./selectbaseProduct.vue?vue&type=template&id=13bcc352&scoped=true&"
import script from "./selectbaseProduct.vue?vue&type=script&lang=js&"
export * from "./selectbaseProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bcc352",
  null
  
)

export default component.exports